import { useEffect, useRef } from 'react';
import { renderBarChart, renderBarChartHorizontal, renderChart } from './renderBarChart';

/*
export function BarChart(props) {
  const canvasRef = useRef(null);

  useEffect(() => {
    if (!canvasRef.current) return;

    let chart = undefined;
    if (props.horizontal) chart = renderBarChartHorizontal(canvasRef.current)
    else chart = renderBarChart(canvasRef.current);

    return () => {
      chart.destroy();
    };
  }, []);

  return (
    <canvas
      ref={canvasRef}
      width={400}
      height={210}
      style={{ display: 'block' }}
    />
  );
}
*/

export function Chart(props) {
  const canvasRef = useRef(null);
  const chartRef = useRef(null);

  useEffect(() => {
    if (!canvasRef.current) return;
    if (!props.metadata) return;

    //let chart = undefined;
    if (props.metadata.ccResize) chartRef.current.destroy();
    if (props.horizontal) chartRef.current = renderChart(canvasRef.current, props.metadata)
    else chartRef.current = renderChart(canvasRef.current, props.metadata);

    return () => {
      chartRef.current.destroy();
    };
  }, [props.metadata]);

  return (<canvas
      ref={canvasRef}
      key={`${props.metadata.ccWidth}-${props.metadata.ccHeight}`}
      width={props.metadata.ccWidth}
      height={props.metadata.ccHeight}
      style={{ display: 'block' }}
    />
  );
}
